import { z } from 'zod';
import { MediaSchema } from './medias.js';
import { DateCivileSchema, ProseBilingueSchema, SlugSchema, TexteBilingueSchema, } from './textes.js';
export const CoupureDePresseSchema = z.object({
    titre: TexteBilingueSchema,
    source: z.string().min(1),
    date: DateCivileSchema,
    url: z.url().optional(),
    extrait: TexteBilingueSchema.optional(),
});
export const ArtisteSchema = z.object({
    slug: SlugSchema,
    /** Le nom d'un artiste ne se traduit pas. */
    nom: z.string().min(1),
    /** « né en 1978 à Anvers, vit et travaille à Bruxelles ». */
    mention: TexteBilingueSchema.optional(),
    bio: ProseBilingueSchema,
    portrait: MediaSchema.optional(),
    /** Vrai pour la liste « artistes représentés », faux pour un invité. */
    represente: z.boolean(),
    /** Slugs d'œuvres, dans l'ordre voulu par la galerie. */
    oeuvres: z.array(SlugSchema),
    /** Slugs d'expositions et de foires. */
    expositions: z.array(SlugSchema),
    presse: z.array(CoupureDePresseSchema),
});
//# sourceMappingURL=artistes.js.map